import { Controller } from '@hotwired/stimulus'

export default class ModalEventController extends Controller {
  dispatchShowModalEvent (data) {
    const event = new window.CustomEvent('show-modal', { detail: data })

    window.dispatchEvent(event)
  }
}
